var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mx-auto"},[_c('vdata-table',{attrs:{"data":_vm.filteredGroups,"headers":_vm.headers}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }